import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { BrokerConfig } from './schema';
import { fetchConfig, applyBrandTokens } from './loader';

interface ConfigState {
  config: BrokerConfig | null;
  error: string | null;
  loading: boolean;
}

const ConfigContext = createContext<ConfigState>({ config: null, error: null, loading: true });

export function ConfigProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<ConfigState>({ config: null, error: null, loading: true });

  useEffect(() => {
    fetchConfig()
      .then((cfg) => {
        applyBrandTokens(cfg);
        setState({ config: cfg, error: null, loading: false });
      })
      .catch((e: Error) => {
        setState({ config: null, error: e.message, loading: false });
      });
  }, []);

  return <ConfigContext.Provider value={state}>{children}</ConfigContext.Provider>;
}

export function useConfigState(): ConfigState {
  return useContext(ConfigContext);
}

export function useConfig(): BrokerConfig {
  const { config } = useContext(ConfigContext);
  if (!config) throw new Error('useConfig called before config loaded');
  return config;
}
